<!-- <div class="row m-4">
  <div class="col-md-3">
    <app-navbar></app-navbar>
  </div>
  <div class="col-md-4">
    <h1 class="center"><i class="fas fa-folder"
        style="margin-right: 6px;color: rgb(202,1,1);font-size: 28px;"></i>Folders
      <b>Manager</b>
    </h1>
  </div>
</div> -->

<div class=" m-auto container-fluid">

  <div class="mt-lg-4">
    <div class="row">

    </div>
    <div class="row mt-3">
      <div class="col-lg-5">
        <app-treeview-systems

          title="Systems"
          [sort_by] = sort_tree_by
          (messageSelectedFolder)="receiveMessage2($event)"
          (messageEvent)="receiveMessage($event)">
        </app-treeview-systems>

      </div>
      <div class="col-lg-7">

        <mat-tab-group>
          <!-- <mat-tab label="Upload Data">
            <div class="mt-3 ml-2">
              <h3>please, make sure of the data format, should be <b style="color:red;">IP,PASSWORD</b></h3>
              <h6>{{msg_upload}}</h6>
              <textarea (change)="parse_bulk_data()" name="" id="csv_data" cols="30" rows="10"></textarea>
              <br><button (click)="upload_systems_to_folder()"
                [disabled]="disable_upload_button || selected_parent_folder_name.length == 0" color="primary"
                class="m-2" mat-raised-button>Upload <span *ngIf="parsed_data.length>0">{{parsed_data.length}} system to
                  {{selected_parent_folder_name}}</span> </button>
              <p [hidden]="selected_parent_folder_name ">please select destination folder.</p>
            </div>
          </mat-tab> -->

          <mat-tab label="Create folder">

            <mat-horizontal-stepper [linear]="isLinear" #stepper>
              <mat-step [stepControl]="CreateFolder_FormGroup">
                <form (ngSubmit)="onSubmit_create_folder()" [formGroup]="CreateFolder_FormGroup">
                  <ng-template matStepLabel>Fill out Folder information</ng-template>
                  <mat-form-field>
                    <mat-label>Folder Name</mat-label>
                    <input matInput placeholder="Aa" formControlName="item_name" required>
                  </mat-form-field>

                  <mat-radio-group formControlName="item_parent_id" aria-label="Select an option">
                    <br>
                    <mat-radio-button value="0">Create as a root</mat-radio-button>
                    <br>
                    <mat-radio-button [value]="selected_parent_folder_id">Create as a subfolder
                      <span [hidden]="!selected_folder">under <b>({{selected_parent_folder_name}})</b></span>
                    </mat-radio-button>
                  </mat-radio-group>
                  <div style="color:red;margin-left: 15px; font-size: small;" *ngIf="disableCreateButton()">{{updateBtnErrorMsg}}</div>
                  <div>
                    <button (click)="create_response_message=''" color="primary" type="submit" mat-button matStepperNext
                      [disabled]="!CreateFolder_FormGroup.valid || disableCreateButton()">Save Folder
                    </button>
                  </div>
                </form>
              </mat-step>

              <mat-step>
                <ng-template matStepLabel>Done</ng-template>
                <p>You are now done.</p>
                <p>result : {{create_response_message}}</p>
                <div>
                  <button mat-button matStepperPrevious>Back</button>
                  <button mat-button (click)="CreateFolder_FormGroup.reset();create_response_message='';">Reset</button>

                </div>
              </mat-step>
            </mat-horizontal-stepper>
          </mat-tab>
          <mat-tab label="Update folder">

            <mat-vertical-stepper [linear]="isLinear" #stepper>
              <mat-step [stepControl]="updateFolderForm">
                <form (ngSubmit)="onSubmit_update_folder()" [formGroup]="updateFolderForm">
                  <ng-template matStepLabel>Select a folder to update</ng-template>
                  <mat-form-field>
                    <mat-label>New Name</mat-label>
                    <input [(value)]="selected_parent_folder_name" matInput placeholder="folder name"
                      formControlName="item_name" required>
                    <input formControlName="id" hidden="hidden" type="text" [(value)]="selected_parent_folder_id">
                  </mat-form-field>
                  <div>
                    <button (click)="update_response_message=''" mat-button matStepperNext>Next</button>
                  </div>
                </form>
              </mat-step>

              <mat-step>
                <ng-template matStepLabel>Done</ng-template>
                <p>You are now done.</p>
                <p>result:{{update_response_message}}</p>
                <div>
                  <button mat-button matStepperPrevious>Back</button>
                  <button mat-button (click)="updateFolderForm.reset();update_response_message=''">Reset</button>
                </div>
              </mat-step>
            </mat-vertical-stepper>


          </mat-tab>
          <mat-tab label="Move folder">
            <!-- select source -->

            <p *ngIf="!selected_folder && !this.moveFolderFormGroup.get('item_src_name').value ">Select a folder to
              move.</p>
            <div *ngIf="selected_folder && !this.moveFolderFormGroup.get('item_src_name').value ">
              <p>use <b>{{selected_parent_folder_name}}</b> as a <b>source folder</b> ? </p>
              <p class="text-muted">Or select another folder from the tree.</p>
              <button color="primary" (click)="assign_move_src_folder(selected_folder);" mat-raised-button>set</button>
              <button color="light" class="m-1" (click)="this.moveFolderFormGroup.reset();selected_parent_folder_name = '';selected_parent_folder_id='';selectedFolderToMove=null;moveFolderErrorMessage=null " mat-raised-button>clear</button>

            </div>
            <!-- source:: selected -->
            <div *ngIf="this.moveFolderFormGroup.get('item_src_name').value ">
              <p>1. Source <b>{{this.moveFolderFormGroup.get('item_src_name').value }}</b></p>

            <!-- select a destination  -->
            <div *ngIf="!this.moveFolderFormGroup.get('item_dest_name').value">
              <p *ngIf="!this.moveFolderFormGroup.get('item_dest_name').value">- select a destination folder..</p>
              <p *ngIf="!this.moveFolderFormGroup.get('item_dest_name').value">2. Destination: <b>{{selected_parent_folder_name}}</b></p>
              <button (click)="submit_move_folder('root')" class="m-1" *ngIf="!this.moveFolderFormGroup.get('item_dest_name').value" color="primary"
              mat-raised-button>Make root</button>


            </div>
            <p *ngIf="this.moveFolderFormGroup.get('item_dest_name').value">2. Destination: <b>{{this.moveFolderFormGroup.get('item_dest_name').value }}</b></p>

            <button class="m-1"  [disabled]="disableMoveButton()" *ngIf="selected_parent_folder_name" color="primary"
            (click)="assign_move_dest_folder(selected_folder);" mat-raised-button>set</button>
            <div style="color:red;margin-left: 15px; font-size: small;" *ngIf="disableMoveButton()">{{updateBtnErrorMsg}}</div>
            <button color="light" class="m-1" (click)="this.moveFolderFormGroup.reset();selected_parent_folder_name = '';selected_parent_folder_id='';destinationFolder=null;moveFolderErrorMessage=null " mat-raised-button>clear</button>



            <div *ngIf="this.moveFolderFormGroup.valid" class="mt-4">

              <button class="m-1" (click)="submit_move_folder('')"
               mat-raised-button color="primary">
               Move to {{this.moveFolderFormGroup.get('item_dest_name').value}}
              </button>
              
              <p style="color: red;" *ngIf="moveFolderErrorMessage">{{moveFolderErrorMessage}}</p>
               <br>

              <button class="m-1" mat-button (click)="this.moveFolderFormGroup.reset();parent_folder_id =''"
                color="secondary">Reset</button><br>
            </div>

          </div>
          <p *ngIf="move_response_message">Result: {{move_response_message}}</p>

          </mat-tab>
          <mat-tab label="Delete folder">

            <mat-vertical-stepper [linear]="isLinear" #stepper>
              <mat-step [stepControl]="deleteFolderFormGroup">
                <form (ngSubmit)="onSubmit_delete_folder()" [formGroup]="deleteFolderFormGroup">
                  <ng-template matStepLabel>Select a folder to Delete</ng-template>
                  <mat-form-field>
                    <mat-label>Folder Name</mat-label>
                    <input formControlName="item_name" [(value)]="selected_parent_folder_name" matInput placeholder="folder name"
                       required>
                    <input formControlName="id" hidden="hidden" type="text" [(value)]="selected_parent_folder_id">
                  </mat-form-field>
                  <div>
                    <button (click)="delete_response_message=''" [disabled]="!selected_parent_folder_id" mat-button matStepperNext>Next</button>
                  </div>
                </form>
              </mat-step>

              <mat-step>
                <ng-template matStepLabel>Done</ng-template>
                <p>You are now done.</p>
                <p>result: {{delete_response_message}}</p>
                <div>
                  <button mat-button matStepperPrevious>Back</button>
                  <button mat-button (click)="deleteFolderFormGroup.reset();delete_response_message=''">Reset</button>
                </div>
              </mat-step>
            </mat-vertical-stepper>
          </mat-tab>
        </mat-tab-group>

      </div>
    </div>
  </div>
</div>
